import Api from "./Api"

const CREATE = `${process.env.REACT_APP_API_SERVER}/api/v1/cartingorder`
const UPDATE = `${process.env.REACT_APP_API_SERVER}/api/v1/cartingorder/update`
const NOC_UPDATE = `${process.env.REACT_APP_API_SERVER}/api/v1/cartingorder/nocUpdate`
const GET =(id)=> `${process.env.REACT_APP_API_SERVER}/api/v1/cartingorder/${id}`
const ONHOLD =(id)=> `${process.env.REACT_APP_API_SERVER}/api/v1/cartingorder/onhold/${id}`
const INTRANSIT =(id)=> `${process.env.REACT_APP_API_SERVER}/api/v1/cartingorder/intransit/${id}`
const CLAIM = `${process.env.REACT_APP_API_SERVER}/api/v1/cartingorder/claim`
const CFSLocations = `${process.env.REACT_APP_API_SERVER}/api/v1/cartingorder/get/cfslocations`
const REVERT_CARTING = `${process.env.REACT_APP_API_SERVER}/api/v1/cartingorder/revert/cartingbooking`
const CHECKCARTING = `${process.env.REACT_APP_API_SERVER}/api/v1/cartingorder/checkcarting`

export default class CartingOrderApi {
    static CreateCartingorder(d,callback = f => f){
        Api.post(CREATE, d, (data) => {
            callback(data)
        })
    }

    static UpdateCartingorder(d,callback = f => f){
        Api.post(UPDATE, d, (data) => {
            callback(data)
        })
    }

    static moveNOCOrder(d,callback = f => f){
        Api.post(NOC_UPDATE, d, (data) => {
            callback(data)
        })
    }

    static async getcartingorderbyid(id,callback) {
        Api.fetch(GET(id),(data) => {
            callback(data)
        })
    }

    static async getcartingorderonhold(id,callback) {
        Api.fetch(ONHOLD(id),(data) => {
            callback(data)
        })
    }

    static async getcartingorderintransit(id,callback) {
        Api.fetch(INTRANSIT(id),(data) => {
            callback(data)
        })
    }

    static ClaimCartingorder(d,callback = f => f){
        Api.post(CLAIM, d, (data) => {
            callback(data)
        })
    }

    static Checkcarting(d,callback = f => f){
        Api.post(CHECKCARTING, d, (data) => {
            callback(data)
        })
    }

    static async getCfslocations(callback) {
        Api.fetch(CFSLocations,(data) => {
            callback(data)
        })
    }

    static revertCartingBooking(booking, callback = f => f){
        Api.post(REVERT_CARTING, booking, (data) => {
            callback(data)
        })
    }
}